/* eslint-disable import/no-cycle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfoIcon from '../../icons/icon-info.svg';
import TooltipHOC from '../TooltipHOC/TooltipHOC';
import CustomReactMarkdown from '../MarkdownRenderers/CustomReactMarkdown';
import { styler } from '../../helpers/classNameHelper';


class MarketplaceTooltip extends Component {
  constructor(props) {
    super(props);
    if (props.hideIcon) {
      props.setConfig({ iconDimensions: 0, alignMsg: 'left', title: props.title });
    } else {
      props.setConfig({ iconDimensions: 16, alignMsg: 'right', title: props.title });
    }
  }

  render() {
    const {
      title,
      message,
      display,
      hideIcon,
      styleFlag,
      renderMsgBlock,
      commodityValue,
    } = this.props;

    if (!display) {
      return null;
    }

    const tooltipTitle = commodityValue ? `${commodityValue} ${title}` : title;
    const style = styler(styleFlag);

    return (
      <span className={style('marketplace-tooltip__header')}>
        <CustomReactMarkdown source={tooltipTitle} noWrapper />
        {!hideIcon && (
          <InfoIcon className={style('marketplace-tooltip__info-icon')} />
        )}
        {renderMsgBlock((
          <CustomReactMarkdown
            source={message}
            className={style('marketplace-tooltip__msg-block')}
            renderers={{ root: 'span', paragraph: 'span' }}
          />
        ))}
      </span>
    );
  }
}

MarketplaceTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  setConfig: PropTypes.func.isRequired,
  styleFlag: PropTypes.string.isRequired,
  renderMsgBlock: PropTypes.func.isRequired,
  display: PropTypes.bool,
  hideIcon: PropTypes.bool,
  message: PropTypes.string,
  commodityValue: PropTypes.string,
};

MarketplaceTooltip.defaultProps = {
  message: '',
  display: true,
  hideIcon: false,
  commodityValue: null,
};

export default TooltipHOC(MarketplaceTooltip);
